(() => {
  const INCOMPLETE_ATTR = 'data-table-pair-incomplete';

  const syncGate = () => {
    const gate = document.querySelector('[data-table-pair-gate]');
    const incomplete = gate?.getAttribute('data-incomplete') === 'true';
    document.documentElement.setAttribute(INCOMPLETE_ATTR, incomplete ? 'true' : 'false');
    document.querySelectorAll('[name="checkout"]').forEach((button) => {
      if (incomplete) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
      } else if (button.hasAttribute('data-table-pair-managed')) {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
      }
    });
  };

  const markCheckoutButtons = () => {
    document.querySelectorAll('[name="checkout"]').forEach((button) => {
      button.setAttribute('data-table-pair-managed', 'true');
    });
  };

  document.addEventListener('cart:updated', () => {
    markCheckoutButtons();
    syncGate();
  });

  document.addEventListener(
    'submit',
    (event) => {
      if (document.documentElement.getAttribute(INCOMPLETE_ATTR) !== 'true') return;
      const submitter = event.submitter;
      if (submitter?.getAttribute('name') === 'checkout') {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  if (FoxTheme?.pubsub?.subscribe && FoxTheme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => {
      // Cart drawer/footer HTML may update after this event's handlers run.
      requestAnimationFrame(() => {
        markCheckoutButtons();
        syncGate();
      });
    });
  }

  markCheckoutButtons();
  syncGate();
})();
